routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider']

// config file
import GlobalConfig from '../../../../../../globals/globalConfig.json'

export default function routes ($stateProvider, $urlRouterProvider, $locationProvider) {
  $locationProvider.html5Mode(true)
  $stateProvider
  .state('workplan.reviewInvestigation', {
    abstract: false,
    url: '/reviewInvestigation/teacher/:teacherId?name/workplan/:workplanId',
    template: '<activities-review></activities-review>',
    module: GlobalConfig.modules.investigation,
    data: {
      displayName: 'Investigación',
      title: 'Investigación',
      order: 2,
      siblings: [
        {
          name: 'fullscreen.workPlanReview',
          order: 0
        },
        {
          name: 'workplan.reviewTeaching',
          order: 1,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewAcademicManagement',
          order: 4,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewConsolidation',
          order: 5,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewExtension',
          order: 3,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.summaryReview',
          order: 6,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        }
      ]
    },
    params: {
      stage: GlobalConfig.workplanStages.review,
      roleId: GlobalConfig.userRolesIds.reviewer,
      inHistory: false
    }
  })
  .state('workplan.approvalInvestigation', {
    abstract: false,
    url: '/approvalInvestigation/teacher/:teacherId?name/workplan/:workplanId',
    template: '<activities-review></activities-review>',
    module: GlobalConfig.modules.investigation,
    data: {
      displayName: 'Investigación',
      title: 'Investigación',
      order: 2,
      siblings: [
        {
          name: 'fullscreen.workPlanApproval',
          order: 0
        },
        {
          name: 'workplan.approvalTeaching',
          order: 1,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.approvalAcademicManagement',
          order: 4,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.approvalConsolidation',
          order: 5,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.approvalExtension',
          order: 3,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.summaryApproval',
          order: 6,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        }
      ]
    },
    params: {
      stage: GlobalConfig.workplanStages.approval,
      roleId: GlobalConfig.userRolesIds.approver,
      inHistory: false
    }
  })
  .state('workplan.executionInvestigation', {
    abstract: false,
    url: '/executionInvestigation',
    template: '<activities-review></activities-review>',
    module: GlobalConfig.modules.investigation,
    data: {
      displayName: 'Investigación',
      title: 'Investigación',
      order: 2,
      siblings: [
        {
          name: 'fullscreen.workPlanExecution',
          order: 0
        },
        {
          name: 'workplan.executionTeaching',
          order: 1
        },
        {
          name: 'workplan.executionAcademicManagement',
          order: 4
        },
        {
          name: 'workplan.executionConsolidation',
          order: 5
        },
        {
          name: 'workplan.executionExtension',
          order: 3
        },
        {
          name: 'workplan.executionHistory',
          order: 6
        }
      ]
    },
    params: {
      stage: GlobalConfig.workplanStages.execution,
      roleId: GlobalConfig.userRolesIds.teacher,
      inHistory: false
    }
  })
  .state('workplan.reviewExecutionInvestigation', {
    abstract: false,
    url: '/reviewExecutionInvestigation/teacher/:teacherId?name/workplan/:workplanId',
    template: '<activities-review></activities-review>',
    module: GlobalConfig.modules.investigation,
    data: {
      displayName: 'Investigación',
      title: 'Investigación',
      order: 2,
      siblings: [
        {
          name: 'fullscreen.workPlanReviewExecution',
          order: 0
        },
        {
          name: 'workplan.reviewExecutionTeaching',
          order: 1,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewExecutionAcademicManagement',
          order: 4,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewExecutionConsolidation',
          order: 5,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewExecutionExtension',
          order: 3,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.summaryReviewExecution',
          order: 6,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        }
      ]
    },
    params: {
      stage: GlobalConfig.workplanStages.reviewExecution,
      roleId: GlobalConfig.userRolesIds.reviewer,
      inHistory: false
    }
  })
  .state('workplan.evaluationInvestigation', {
    abstract: false,
    url: '/evaluationInvestigation/teacher/:teacherId?name/workplan/:workplanId',
    template: '<activities-review></activities-review>',
    module: GlobalConfig.modules.investigation,
    data: {
      displayName: 'Investigación',
      title: 'Investigación',
      order: 2,
      siblings: [
        {
          name: 'fullscreen.workPlanEvaluation',
          order: 0
        },
        {
          name: 'workplan.evaluationTeaching',
          order: 1,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.evaluationAcademicManagement',
          order: 4,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.evaluationConsolidation',
          order: 5,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.evaluationExtension',
          order: 3,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.summaryEvaluation',
          order: 6,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        }
      ]
    },
    params: {
      stage: GlobalConfig.workplanStages.evaluation,
      roleId: GlobalConfig.userRolesIds.approver,
      inHistory: false
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/partials/review/routes/investigation.route.js